import styled from "@emotion/styled";

export const Text = styled.span``;
